import React from 'react';

import DefaultEditor from "react-simple-wysiwyg";


const AddTemplate = () => {
 const [values, setValue] = React.useState();
    function onChange(e) {
        setValue(e.target.value);
      }
    
  return (
    <>
    <div
            className="offcanvas offcanvas-end"
            tabIndex={-1}
            id="offcanvasAddTemplate"
            aria-labelledby="offcanvasAddTemplate"
            style={{ minWidth: "40%", maxWidth: "40%" }}
          >
            <div className="offcanvas-header bg-primary">
              <h4 id="AddTemplate" className="text-white">
                Add Template
              </h4>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            <hr />
            <div className="offcanvas-body">
              <form>
                <div className="mb-3 col-12">
                  <label>Template Title</label>
                  <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Template Title"
                          required
                        />
                </div>
                <div className="mb-3">
                  <label className="form-label">Set Reminder To</label>
                  <select className="form-select">
                    <option>A</option>
                    <option>B</option>
                  </select>
                </div>
                <div className="mb-3 mt-1 col-12">
                          <label>Template Content</label>
                           <DefaultEditor   value={values} onChange={onChange} />
                        </div>
                <div className="page-btn ">
                  <button className="btn btn-primary page-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
    </>
  )
}

export default AddTemplate
